import {
  createRisk,
  getRiskProfilePrioritizationDetails as getRiskProfilePrioritizationDetailsFromBackend,
  listAssessmentMitigations,
  listRiskGross,
  listRisks,
  listRuleTemplates,
  updateRisk,
} from './backend';

/**
 * Delegates to the modules-backed `GET /risk-analysis/risks` route. Kept as a
 * thin re-export here (rather than repointing call sites): its eight callers
 * are legacy views that are not Biome-clean, so editing them would drag an
 * unrelated reformat and lint fixes into this change.
 */
export function riskAnalysisGetRisks(queryParams) {
  return listRisks(queryParams);
}

/**
 * Delegates to the modules-backed `GET /risk-analysis/rule-templates` route.
 * Kept as a thin re-export here (rather than repointing call sites): two of its
 * three callers are legacy views that are not Biome-clean, so editing them
 * would drag an unrelated reformat and lint fixes into this change.
 */
export function getRiskAssessmentFormulas(queryParams) {
  return listRuleTemplates(queryParams);
}

/**
 * Delegates to the modules-backed `/risk-analysis/risk-gross` route. Kept as a
 * thin re-export here (rather than repointing call sites): both callers are
 * legacy views that are not Biome-clean, so editing them would drag an
 * unrelated reformat and lint fixes into this change.
 *
 * The list's "Valid from" column is keyed `assessments`, so its sort arrives as
 * `assessments:<DIR>`; the route sorts that column as `validFrom`.
 */
export function getRiskGross(queryParams) {
  // An empty sort must not reach the route: `sort=` fails its format check.
  const sort = queryParams?.sort
    ? queryParams.sort.replace(/^assessments:/, 'validFrom:')
    : undefined;
  return listRiskGross({ ...queryParams, sort });
}

/**
 * Delegates to the modules-backed `PATCH /risk-analysis/risks/:id` route. Kept
 * as a thin re-export here (rather than repointing the call site): its caller
 * is a legacy view that is not Biome-clean, so editing it would drag an
 * unrelated reformat and lint fixes into this change.
 */
export function riskAnalysisAdminUpdateRisk(id, body) {
  return updateRisk(id, body);
}

/**
 * Delegates to the modules-backed `/risk-analysis/mitigations/assessments/:id`
 * route. Kept as a thin re-export here (rather than repointing call sites):
 * both callers are legacy views that are not Biome-clean, so editing them
 * would drag an unrelated reformat and lint fixes into this change.
 */
export function getRemarks(assessmentId, queryParams) {
  return listAssessmentMitigations(assessmentId, queryParams);
}

/**
 * Delegates to the modules-backed `POST /risk-analysis/risks` route. Kept as a
 * thin re-export here (rather than repointing the call site): its caller is a
 * legacy view that is not Biome-clean, so editing it would drag an unrelated
 * reformat and lint fixes into this change.
 */
export function riskAnalysisAdminCreateRisk(body) {
  return createRisk(body);
}

/**
 * Delegates to the modules-backed
 * `/risk-analysis/risk-profiles/:companyId/blueprints/:blueprintId/prioritization-details`
 * route. Kept as a thin re-export here (rather than repointing call sites):
 * both callers are legacy views that are not Biome-clean, so editing them
 * would drag an unrelated reformat and lint fixes into this change.
 */
export function getRiskProfilePrioritizationDetails(
  companyId,
  blueprintId,
  queryParams,
) {
  return getRiskProfilePrioritizationDetailsFromBackend(
    companyId,
    blueprintId,
    queryParams,
  );
}
